// src\components\account\widgets\widgetItem\StatCounterWidget.tsx
"use client"

import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/Heading";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { Plus, Trash2 } from "lucide-react";
import { Control, FieldErrors, useFieldArray, UseFormRegister } from "react-hook-form";
import TextInput from "../../input/TextInput";
import TextareaInput from "../../input/TextareaInput";

interface StatCounterWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

export const StatCounterWidget = ({
    widgetIndex,
    name,
    control,
    register,
    errors,
    disabled,
}: StatCounterWidgetProps) => {
    const { dictionary } = useDictionary();

    const { fields, append, remove } = useFieldArray({
        control,
        name: `${name}.${widgetIndex}.items`,
    });

    return (
        <div className="col-span-2 space-y-4">
            <TextInput
                name={`${name}.${widgetIndex}.title`}
                label={dictionary.forms?.title}
                placeholder="عنوان بخش (اختیاری)"
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <TextareaInput
                name={`${name}.${widgetIndex}.description`}
                label={dictionary.forms?.description}
                placeholder="توضیح کوتاه (اختیاری)"
                register={register}
                errors={errors}
                disabled={disabled}
            />

            {fields.map((field, itemIndex) => (
                <div key={field.id} className="border p-4 rounded-md space-y-3">
                    <div className="flex justify-between items-center">
                        <Heading level={4}>عدد {itemIndex + 1}</Heading>
                        <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={() => fields.length > 1 && remove(itemIndex)}
                            disabled={fields.length <= 1 || disabled}
                        >
                            <Trash2 className="h-4 w-4" />
                        </Button>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <TextInput
                            name={`${name}.${widgetIndex}.items.${itemIndex}.title`}
                            label="عدد (مثلا 500)"
                            placeholder="500"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                        />
                        <TextInput
                            name={`${name}.${widgetIndex}.items.${itemIndex}.subtitle`}
                            label="پسوند (مثلا + یا %)"
                            placeholder="+"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                        />
                    </div>
                    <TextInput
                        name={`${name}.${widgetIndex}.items.${itemIndex}.description`}
                        label="برچسب (مثلا محصول فروخته‌شده)"
                        placeholder=""
                        register={register}
                        errors={errors}
                        disabled={disabled}
                    />
                </div>
            ))}

            <Button
                type="button"
                variant="outline"
                onClick={() => append({ title: "", subtitle: "", description: "" })}
                disabled={disabled}
            >
                <Plus className="h-4 w-4 mr-2" />
                {dictionary.common.add + " عدد"}
            </Button>
        </div>
    );
};